package com.trevorwiebe.timesheet.calendar.presentation.composables

import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.foundation.background
import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.trevorwiebe.timesheet.calendar.presentation.uiHelper.DayUi
import com.trevorwiebe.timesheet.calendar.presentation.uiHelper.TimeOffRequestUi
import com.trevorwiebe.timesheet.core.domain.Util
import kotlin.time.Clock
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.time.ExperimentalTime

@OptIn(ExperimentalFoundationApi::class, ExperimentalTime::class)
@Composable
fun DayList(
    dayUi: DayUi,
    onClick: () -> Unit,
    onLongClick: () -> Unit,
    onEmployeeSelected: (TimeOffRequestUi) -> Unit,
) {

    val day = remember { Util.toFriendlyDayOfWeek(dayUi.date) }
    val date = remember { Util.toFriendlyDate(dayUi.date) }

    val background = if (dayUi.selectedForTimeOff) MaterialTheme.colorScheme.tertiary else MaterialTheme.colorScheme.surface
    val todayLabelBackground = if (dayUi.selectedForTimeOff) MaterialTheme.colorScheme.background else MaterialTheme.colorScheme.tertiary
    val todayLabelTextColor = if (dayUi.selectedForTimeOff) MaterialTheme.colorScheme.onBackground else MaterialTheme.colorScheme.onTertiary
    val otherDateTextColor = if (dayUi.selectedForTimeOff) MaterialTheme.colorScheme.onTertiary else MaterialTheme.colorScheme.onSurface

    Column(
        modifier = Modifier
            .padding(4.dp)
            .clip(RoundedCornerShape(8.dp))
            .combinedClickable(
                onClick = { onClick() },
                onLongClick = { onLongClick() }
            )
            .fillMaxWidth()
            .background(background)
            .padding(4.dp, 4.dp, 4.dp, 8.dp)
    ) {
        if (dayUi.date == Clock.System.now()
                .toLocalDateTime(TimeZone.currentSystemDefault()).date
        ) {
            TodayListDateLabel(
                day = day,
                date = date,
                backgroundColor = todayLabelBackground,
                textColor = todayLabelTextColor
            )
        } else {
            Row(
                modifier = Modifier.fillMaxWidth()
            ) {
                Text(
                    modifier = Modifier.padding(8.dp, 8.dp, 8.dp, 0.dp),
                    text = day,
                    color = otherDateTextColor
                )
                Spacer(modifier = Modifier.weight(1f))
                Text(
                    modifier = Modifier.padding(8.dp, 8.dp, 8.dp, 0.dp),
                    text = date,
                    color = otherDateTextColor
                )
            }
        }

        dayUi.employeesOff.forEach {
            DayListEventItem(
                timeOffRequestModel = it,
                approved = it.request.approved,
                onClick = { onEmployeeSelected(it) }
            )
        }
    }
}